import { useCallback, useState } from 'react'
import { DatePickerTypeValue } from '../../DatePicker/DatePickerType'
import { TodoItem } from 'pages/todo/modules/TodoItem'

interface DatePickerState {
  isOpen: boolean
  pickerType: DatePickerTypeValue
  value: Date | null
  todo: TodoItem | null
  onConfirm: ((date: Date) => void) | null
}

interface UseDatePickerReturn {
  datePickerState: DatePickerState
  openDatePicker: (
    pickerType: string,
    value: Date | null,
    onChange: (date: Date | null) => void,
  ) => void
  closeDatePicker: () => void
  handleDatePickerConfirm: (date: Date) => void
}

/**
 * Date picker 상태 관리 훅
 * @returns {Object} Date picker 관련 상태와 핸들러들
 */
export const useDatePicker = (): UseDatePickerReturn => {
  const [datePickerState, setDatePickerState] = useState<DatePickerState>({
    isOpen: false,
    pickerType: 'date',
    value: null,
    todo: null,
    onConfirm: null,
  })

  const openDatePicker = useCallback(
    (pickerType: string, value: Date | null, onChange: (date: Date | null) => void) => {
      setDatePickerState({
        isOpen: true,
        pickerType: pickerType as DatePickerTypeValue,
        value,
        todo: null,
        onConfirm: onChange as (date: Date) => void,
      })
    },
    [],
  )

  const closeDatePicker = useCallback(() => {
    setDatePickerState((prev) => ({ ...prev, isOpen: false }))
  }, [])

  const handleDatePickerConfirm = useCallback(
    (date: Date) => {
      if (datePickerState.onConfirm) {
        datePickerState.onConfirm(date)
      }
      closeDatePicker()
    },
    [datePickerState.onConfirm, closeDatePicker],
  )

  return {
    datePickerState,
    openDatePicker,
    closeDatePicker,
    handleDatePickerConfirm,
  }
}
